import { inject, injectable } from "inversify";
import type { IAutoSyncDataLayer } from "../types/IAutoSyncDataLayer";
import { action, computed, makeObservable, observable } from "mobx";
import { AutoSyncDataLayerSymbol } from "./AutoSyncDataLayerSymbol";
import { fromPromise } from "mobx-utils";

@injectable()
export class AutoSyncSettingsStore {
  confirmText = "";
  isDeleting = false;
  constructor(@inject(AutoSyncDataLayerSymbol) private crmSettingsDataLayer: IAutoSyncDataLayer) {
    makeObservable(this, {
      confirmText: observable,
      isSubmitDisabled: computed,
      setConfirmText: action,
      isDeleting: observable,
      setIsDeleting: action,
      init: computed,
    });
  }

  get init() {
    return fromPromise(this.crmSettingsDataLayer.checkPermission ? this.crmSettingsDataLayer.checkPermission() : Promise.resolve());
  }

  get isSubmitDisabled() {
    return this.confirmText !== "DELETE ALL";
  }

  setConfirmText(text: string) {
    this.confirmText = text;
  }

  async deleteAllMessages() {
    await this.crmSettingsDataLayer.deleteAllMessages();
  }

  setIsDeleting(state: boolean) {
    this.isDeleting = state;
  }
}
